{
  "_comment": "[CI-LOCKED] Sadržaj ove datoteke blokiran je. Doprinosi su dobrodošli, ali provjera valjanosti promjena može biti odgođena.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Bot $1 rekao je:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "Vi ste rekli:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Priloženi bot:",
  "ACTIVITY_CODE_ALT": "Uzorak koda: $1",
  "ACTIVITY_CONTENT_CAUTION": "Sadržaj generiran umjetnom inteligencijom možda nije ispravan",
  "ACTIVITY_CODE_CAUTION": "Kôd generiran umjetnom inteligencijom. Pregledajte i pažljivo koristite",
  "ACTIVITY_ERROR_BOX_TITLE": "Poruka o pogrešci",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Kliknite za interakciju.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Poruka je interaktivna.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "U poruci se nalazi jedna ili više veza.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Slanje nije uspjelo.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Priložili ste:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 privitak.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 privitka.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 privitaka.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 privitaka.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 privitka.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Slanije nije uspjelo. [Pokušaj ponovno][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Slanje",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Poslano u $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Upravo sada",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Prije 1 h",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Prije 1 minute",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Danas",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Jučer",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Pogreška pri raščlambi prilagodljive kartice",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Pogreška pri renderiranju prilagodljive kartice",
  "ATTACHMENT_AUDIO": "Audioisječak.",
  "ATTACHMENT_CARD": "Kartica: $1 $2 $3",
  "ATTACHMENT_FILE": "Datoteka: $1",
  "ATTACHMENT_IMAGE": "Slika",
  "ATTACHMENT_TEXT": "Tekst: $1",
  "ATTACHMENT_VIDEO": "Videoisječak",
  "AVATAR_ALT": "$1 avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Sljedeće",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Prethodno",
  "CITATION_MODEL_DIALOG_ALT": "Citat",
  "CLOSE_BUTTON_ALT": "Zatvori",
  "COLLAPSIBLE_GROUPING_TITLE": "Razmišljam…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "To se prikazuje kada bot sastavlja odgovor u grupi, a apstrakt nije dostavljen.",
  "COLLAPSE_BUTTON_LESS": "Prikaži manje",
  "COLLAPSE_BUTTON_LESS.comment": "Ovo je tekst gumba sa ševronom za sažimanje grupe poruka. Kada krajnji korisnik klikne na gumb, grupa poruka se smanjuje.",
  "COLLAPSE_BUTTON_MORE": "Prikaži više",
  "COLLAPSE_BUTTON_MORE.comment": "Ovo je tekst gumba sa ševronom za proširenje grupe poruka. Kada krajnji korisnik klikne na gumb, grupa poruka se proširuje.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Povezano",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Povezivanje u tijeku...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Povezivanje nije moguće.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Došlo je do prekida mreže. U tijeku je ponovno povezivanje...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Pogreška pri renderiranju. Provjerite konzolu ili se obratite razvojnom inženjeru bota.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Povezivanje traje dulje nego obično.",
  "CONNECTIVITY_STATUS_ALT": "Status veze: $1",
  "COPY_BUTTON_TEXT": "Kopiraj",
  "COPY_BUTTON_COPIED_TEXT": "Kopirano",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Pošalji",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Otkaži",
  "FEEDBACK_FORM_PLACEHOLDER": "Navedite što više detalja, ali nemojte uključivati ​​privatne ili osjetljive informacije.",
  "FEEDBACK_FORM_TITLE": "Recite nam o svojem iskustvu",
  "FILE_CONTENT_ALT": "„$1”",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Preuzimanje datoteke „$1”",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Preuzimanje datoteke „$1” veličine $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "„$1” veličine $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Otvara se u novom prozoru, vanjskom.",
  "RECEIPT_CARD_TAX": "Porez",
  "RECEIPT_CARD_TOTAL": "Ukupno",
  "RECEIPT_CARD_VAT": "PDV",
  "REFERENCE_LIST_HEADER_ONE": "$1 referenca",
  "REFERENCE_LIST_HEADER_FEW": "$1 reference",
  "REFERENCE_LIST_HEADER_MANY": "$1 reference",
  "REFERENCE_LIST_HEADER_OTHER": "$1 reference",
  "REFERENCE_LIST_HEADER_TWO": "$1 reference",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Izbriši privitak $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Izbriši",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Datoteka",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Slika",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Prazna poruka se ne može poslati.",
  "SPEECH_INPUT_LISTENING": "Slušanje...",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon je isključen",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon je uključen",
  "SPEECH_INPUT_STARTING": "Započinje...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Sljedeće",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Prethodno",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Predložene akcije",
  "TEXT_INPUT_ALT": "Okvir za unos poruke",
  "TEXT_INPUT_PLACEHOLDER": "Unesite poruku",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Započnite razgovor...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Slušanje...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Obrada u tijeku...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Govorite za prekidanje...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Pošalji",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Govor",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Prijenos datoteke",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Tipkovnica telefona",
  "TEXT_INPUT_DROP_ZONE": "Spustite datoteke",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Premašena duljina poruke",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Podržava samo jednoznamenkasti unos",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 privitaka",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 privitaka",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 privitak",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 privitaka",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 privitaka",
  "TOAST_ACCORDION_FEW": "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti",
  "TOAST_ACCORDION_MANY": "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti",
  "TOAST_ACCORDION_OTHER": "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti",
  "TOAST_ACCORDION_TWO": "Obavijesti: $1. Kliknite ovdje za prikaz pojedinosti",
  "TOAST_ALT_ERROR": "Pogreška",
  "TOAST_ALT_INFO": "Informacije",
  "TOAST_ALT_SUCCESS": "Uspjeh",
  "TOAST_ALT_WARN": "Upozorenje",
  "TOAST_DISMISS_BUTTON": "Odbaci",
  "TOAST_TITLE_ALT": "Obavijest",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Povijest čavrljanja, pritisnite tipke sa strelicama za navigaciju.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "povijest čavrljanja",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Poruka je interaktivna. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "U poruci se nalazi jedna ili više veza. Pritisnite tipke Shift i Tab 2 do 3 puta da biste se prebacili na povijest čavrljanja. Zatim za interakciju kliknite poruku.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Poruka sadrži predložene akcije. Pritisnite shift i tabulator 2 do 3 puta da biste ih odabrali.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Poruka sadrži predložene akcije. Pritisnite $1 da biste ih odabrali.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Slanje poruke nije uspjelo.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Dostupne su nove poruke. Pritisnite $1 da biste fokusirali gumb „$2”.",
  "TRANSCRIPT_MORE_MESSAGES": "Više poruka",
  "TRANSCRIPT_NEW_MESSAGES": "Nove poruke",
  "TRANSCRIPT_TERMINATOR_TEXT": "Kraj povijesti čavrljanja",
  "TYPING_INDICATOR_ALT": "Prikaz pokazatelja tipkanja",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 tipka.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 i drugi tipkaju.",
  "VIEW_CODE_BUTTON_TEXT": "Kôd",
  "VOTE_COMPLETE_ALT": "Snimljene povratne informacije",
  "VOTE_COMPLETE_ALT.comment": "Namijenjeno za čitač zaslona. Oznaka gumba s ikonama palac gore/dolje. Oznaka se koristi kada je povratna informacija snimljena.",
  "VOTE_DISLIKE_ALT": "Ne sviđa mi se",
  "VOTE_LIKE_ALT": "Sviđa mi se"
}